import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import ReactSwitch from 'react-switch';
import { useTheme } from 'styled-components';
export var Switch = function (_a) {
  var checked = _a.checked,
    onChange = _a.onChange;
  var theme = useTheme();
  return _jsx(_Fragment, {
    children: _jsx(ReactSwitch, {
      checked: checked,
      onChange: onChange,
      onColor: theme.tokens.accent.token.secondary.regular,
      onHandleColor: theme.tokens.accent.onToken.secondary.regular,
      offColor: theme.tokens.accent.token.secondary.light,
      offHandleColor: theme.tokens.accent.onToken.secondary.regular,
      uncheckedIcon: false,
      checkedIcon: false,
      height: 24,
      width: 40
    })
  });
};
Switch.displayName = 'Switch';